import theme from 'components/theme';
import { getCollectionSchema } from 'functions/schemaHelpers';
import React, { useContext, useEffect } from 'react';
import { CircularProgress } from '@material-ui/core';

// Elements
import CMSBlocks from 'components/cms';
import { makeStyles } from '@material-ui/styles';
import { TrackingContext } from 'components/providers/tracking';
import { JsonLd } from 'react-schemaorg';
import CategoryMeta from './meta';

const useStyles = makeStyles(
	() => ({
		wrapper: {
			paddingBottom: 40
		},
		isLoading: {
			opacity: 0.75
		},
		loader: {
			position: 'fixed',
			left: '50%',
			top: '50%',
			marginLeft: -20,
			zIndex: 1000
		}
	}),
	{ name: 'CategoryPage' }
);

export default function CategoryPage({
	appData,
	category,
	cmsPage,
	breadcrumb,
	categoryMenu,
	isLoading,
	canonicalPathInfo
}) {
	const classes = useStyles();
	const { trackingInitiated, actions } = useContext(TrackingContext);
	const productListingSlot = cmsPage?.sections[0]?.blocks
		?.find(block => block.type === 'product-listing')
		?.slots?.find(slot => slot.type === 'product-listing');

	const schemaData = {
		collection: category,
		productListingSlot,
		breadcrumb,
		orgName: theme.logo.alt,
		baseUrl: appData.meta.basePath || 'https://newport.se',
		currency: appData.meta.currency
	};

	useEffect(() => {
		if (category && !isLoading) { // && trackingInitiated) {
			actions.pageImpression(category.translated.metaTitle || category.translated.name, 'product_list_page');
		}
	}, [isLoading]);

	return (
		<div className={'category-page'}>
			<CategoryMeta category={category} canonicalPath={canonicalPathInfo} />
			<JsonLd item={getCollectionSchema(schemaData)} />
			<div className={isLoading ? classes.isLoading : ''}>
				{isLoading ? <CircularProgress className={classes.loader} /> : ''}
				<CMSBlocks
					cmsPage={cmsPage}
					breadcrumbs={breadcrumb}
					category={category}
					menu={appData.menu}
					categoryMenu={categoryMenu}
				/>
			</div>
		</div>
	);
}
